// extracted by mini-css-extract-plugin
export var copyableField = "_o0-4";
export var customerBadge = "_o0-0";
export var customerInfoTitle = "_o0-2";
export var details = "_o0-1";
export var dropdownContainer = "_o0-5";
export var dropdownImage = "_o0-6";
export var editAssigneeForm = "_o0-a";
export var editButton = "_o0-3";
export var email = "_o0-7";
export var hidden = "_o0-d";
export var input = "_o0-8";
export var saveButton = "_o0-b";
export var shopifyIcon = "_o0-c";
export var suggestionBadge = "_o0-e";
export var suggestionText = "_o0-f";
export var username = "_o0-9";